import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { DocumentiEqualtecResult } from '../models/data.model';

@Pipe({
  name: 'equaltecFilter'
})
@Injectable()
export class EqualtecFilterClass implements PipeTransform {
  transform(item: DocumentiEqualtecResult[], anno?: number, committente?: string, preparatore?: string, annoCreazione?: number, annoPubblicazione?: number): any {
    if (!item || item.length === 0)
      return null;
    if (!anno && !committente && !preparatore && !annoCreazione && !annoPubblicazione)
      return item;
    if (item[0].identificazioneDocumento && item[0].identificazioneDocumento.toLowerCase() == 'record') {
      let lstRecord: DocumentiEqualtecResult[] = []
      item.forEach(element => {
        // estrazione anno dal documento 
        let annoAppoggio = element.documentoWSDto.anno;
        // estrazione committente dal documento
        let committenteAppoggio = element.documentoWSDto.committente
          ? element.documentoWSDto.committente.toLowerCase()
          : undefined;
        // estrazione preparatore dal documento
        let preparatoreAppoggio = element.documentoWSDto.preparatore
          ? element.documentoWSDto.preparatore.toLowerCase()
          : undefined;
        // estrazione anno creazione dal documento
        let dataCreazioneAppoggio = element.documentoWSDto.dataDocumento;
        let annoCreazioneAppoggio = dataCreazioneAppoggio
          ? new Date(dataCreazioneAppoggio).getFullYear()
          : undefined;
        // estrazione anno Pubblicazione dai metadati
        let dataPubblicazioneAppoggio
        if (element.documentoWSDto.metadatiDtoList.length > 0) {
          let metadato = element.documentoWSDto.metadatiDtoList.find(tipo => tipo.key == 'DataPubblicazione');
          dataPubblicazioneAppoggio = metadato ? metadato.value : undefined;
        }
        let annoPubblicazioneAppoggio = dataPubblicazioneAppoggio
          ? new Date(dataPubblicazioneAppoggio).getFullYear()
          : undefined;
        // verifica allineamento dati estratti con parametri di filtro
        if ((anno && annoAppoggio && annoAppoggio === anno)
          || (committente && committenteAppoggio && committenteAppoggio.includes(committente.toLowerCase()))
          || (preparatore && preparatoreAppoggio && preparatoreAppoggio.includes(preparatore.toLowerCase()))
          || (annoCreazione && annoCreazioneAppoggio === annoCreazione)
          || (annoPubblicazione && annoPubblicazioneAppoggio === annoPubblicazione)
        ) {
          lstRecord.push(element);
        }
      });
      return lstRecord
    }
    return item;
  }

}
